import { IMAGE_TYPES } from './image-types.const';
import { PLAIN_TEXT_TYPES } from './plain-text-types.const';
import { VIEWABLE_DOCUMENT_TYPES } from './viewable-document-types.const';

export const VIEWABLE_TYPES = [...PLAIN_TEXT_TYPES, ...IMAGE_TYPES, ...VIEWABLE_DOCUMENT_TYPES];
